import React, { createContext, useCallback, useContext, useEffect, useState } from 'react';
import API from '../lib/api';

const AuthContext = createContext(null);

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [ready, setReady] = useState(false);

  const refresh = useCallback(async () => {
    const token = localStorage.getItem('skyway_token');
    if (!token) { setUser(null); return null; }
    try {
      const { data } = await API.get('/auth/me');
      setUser(data.user);
      return data.user;
    } catch (e) {
      localStorage.removeItem('skyway_token');
      setUser(null);
      return null;
    }
  }, []);

  useEffect(() => {
    (async () => { await refresh(); setReady(true); })();
  }, [refresh]);

  const signIn = async ({ email, password }) => {
    const { data } = await API.post('/auth/login', { email, password });
    localStorage.setItem('skyway_token', data.token);
    setUser(data.user);
    return data.user;
  };

  const register = async (payload) => {
    const { data } = await API.post('/auth/register', payload);
    localStorage.setItem('skyway_token', data.token);
    setUser(data.user);
    return data.user;
  };

  const signOut = () => {
    localStorage.removeItem('skyway_token');
    setUser(null);
  };

  return (
    <AuthContext.Provider value={{ user, ready, signIn, register, signOut, refresh }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => {
  const ctx = useContext(AuthContext);
  if (!ctx) throw new Error('useAuth must be used inside AuthProvider');
  return ctx;
};
